import React from 'react';
import NavLink from './NavLink';
import Dropdown from './Dropdown';
import messages from './messages';
import { linking } from './groups';
import { ImLink } from 'react-icons/all';

const LinkingDropdown = ({ closeSidebar }) => (
  <Dropdown icon={<ImLink />} label={messages.linking}>
    {linking.map((item, index) => (
      <NavLink
        key={index}
        name={item.name}
        icon={item.icon}
        route={item.url}
        role={item.role}
        module={item.module}
        closeSidebar={closeSidebar}
      />
    ))}
  </Dropdown>
);

export default LinkingDropdown;
